module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("No Good Deed")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "nogooddeed.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "contents",
    attrs: {
      "id": "TOC"
    }
  }, [_c('a', {
    attrs: {
      "id": "page08"
    }
  }), _c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('h2', {
    staticClass: "contentsHead"
  }, [_vm._v("Contents")])]), _c('div', {
    staticClass: "contentsEntry"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }), _c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004epigraphpage#epigraphpage"
    }
  }, [_vm._v("Epigraph")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "frontmatterpage_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName1"
  }, [_c('a', {
    attrs: {
      "href": "#/006frontmatterpage#frontmatterpage01"
    }
  }, [_vm._v("Author’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_01"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/007chapter01#chapter01"
    }
  }, [_vm._v("1")]), _vm._v(" The Police Came Knocking")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_02"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/008chapter02#chapter02"
    }
  }, [_vm._v("2")]), _vm._v(" Humpty Dumpty")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_03"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "href": "#/009chapter03#chapter03"
    }
  }, [_vm._v("3")]), _vm._v(" Setting the Scene")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_04"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/010chapter04#chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" Rosie")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_05"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/011chapter05#chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v(" The Wedding")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_06"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/012chapter06#chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" Turning Points for Planned Deaths")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_07"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/013chapter07#chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v(" It’s a Wonderful Life")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_08"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/014chapter08#chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" Discontinuing Dialysis")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_09"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/015chapter09#chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v(" Understanding Olga")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_10"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/016chapter10#chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" The Coalition")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_11"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/017chapter11#chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" Serial Medical Killers")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_12"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('p', {
    staticClass: "contentsEntryName"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('span', {
    attrs: {
      "href": "#/018chapter12#chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" Army of God")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_13"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/019chapter13#chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v(" Amy Goes Downtown")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_14"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/020chapter14#chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")]), _vm._v(" More Murder Accusations")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_15"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/021chapter15#chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" The E-Word Around the World")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_16"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/022chapter16#chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")]), _vm._v(" Sudden Awakening")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_17"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/023chapter17#chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")]), _vm._v(" War on Drugs")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_18"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/024chapter18#chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" The Return")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_19"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/025chapter19#chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")]), _vm._v(" A View from the Bench")])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry",
    attrs: {
      "id": "chapter_20"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName"
  }, [_c('span', {
    attrs: {
      "href": "#/026chapter20#chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" Moving On")])]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "acknowledgment_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName2"
  }, [_c('span', {
    attrs: {
      "href": "#/027acknowledgmentpage#acknowledgmentpage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "aboutauthor_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName2"
  }, [_c('span', {
    attrs: {
      "href": "#/028aboutauthorpage#aboutauthorpage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "credits_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName2"
  }, [_c('span', {
    attrs: {
      "href": "#/029creditspage#creditspage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Credits")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "copyright_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName2"
  }, [_c('span', {
    attrs: {
      "href": "#/030copyrightpage#copyrightpage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])]), _vm._v(" "), _c('div', {
    staticClass: "contentsEntry1",
    attrs: {
      "id": "aboutpublisher_page"
    }
  }, [_c('p', {
    staticClass: "contentsEntryName2"
  }, [_c('span', {
    attrs: {
      "href": "#/031aboutpublisherpage#aboutpublisherpage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Publisher")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9435b676","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/005TOC.vue
// module id = 69
// module chunks = 0